import { useQuery } from "@tanstack/react-query";
import { incomingRepository } from "../repositories/incoming.repository";

export const incomeByIdQueryKey = (id: string) => ["incoming", id, "detail"];

export function useIncomeByIdQuery(id?: string) {
  return useQuery({
    queryKey: incomeByIdQueryKey(id || ""),
    queryFn: () => {
      if (!id) throw new Error("No income id provided");
      return incomingRepository.getIncomingById(id);
    },
    enabled: !!id,
    staleTime: 1000 * 60 * 5,
    gcTime: 60 * 60 * 1000,
    refetchOnMount: "always",
  });
}
